import { cabecalhosDeCorrelacao } from '@titularis/analytics';
import { createApiClient } from '@titularis/api-client';

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3333';

/**
 * O cliente da API, dizendo em qual sessão cada pedido nasceu.
 *
 * **Os cabeçalhos existiam e ninguém os mandava.** O `cabecalhosDeCorrelacao`
 * está no pacote de analytics desde o PR do PostHog e nunca foi chamado, e o
 * `correlacaoDoPedido` do servidor, do outro lado, caía sempre no plano B: sem
 * `X-POSTHOG-SESSION-ID`, o `purchase_confirmed` e o `signup_completed` que o
 * servidor registra apareciam soltos, fora da navegação que levou até eles.
 *
 * Quem costura a visita anônima à conta continua sendo o `identify` do login -
 * isto aqui serve à **sessão**, que é o que o servidor não tem como saber.
 */
export const api = createApiClient({ baseUrl, cabecalhos: cabecalhosDeCorrelacao });
